export const isNode = false;




//////////////////
// WEBPACK FOOTER
// ./node_modules/detect-node-es/esm/browser.js
// module id = 1375
// module chunks = 0